import SnapConsole from "./views/SnapConsole";

const requireAuth = {requireAuth: true}

const SnapConsoleRoute = {
    path: "/snap_console/:idoutlet",
    name: "SnapConsole",
    component: SnapConsole,
    meta: {
        ...requireAuth,
        accessKey: 'smartConsole.read',
    },
}

export default router => {
    router.addRoutes([SnapConsoleRoute])
}
